import styled from 'styled-components'
import TableHead from '@material-ui/core/TableHead'
import TableCell from '@material-ui/core/TableCell'
import MaUTable from '@material-ui/core/Table'
import TableRow from '@material-ui/core/TableRow'

export const Container = styled.div`
  display: block !important;
  @media (max-width: 1100px) {
    display: none !important;
  }
`

export const StyledReactTable = styled(MaUTable)`
  box-shadow: 0px 2px 8px rgba(117, 117, 117, 0.2);
  border-radius: 4px;
`

export const StyledHead = styled(TableHead)`
  background-color: ${({ theme }) => theme.palette.primary.main};
`

export const StyledRow = styled(TableRow)`
  .MuiTableCell-root {
    font-size: 16px;
  }
  .MuiTableCell-root:first-child {
    max-width: 200px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &:nth-of-type(odd) {
    background-color: #fafafa;
  }
`

export const StyledCell = styled(TableCell)`
  button {
    border: none;
    background: transparent;

    img {
      margin-left: 9.33px;

      :hover {
        transform: scale(1.2);
      }
    }
  }
  &&.MuiTableCell-head {
    color: ${({ theme }) => theme.palette.white};
    font-size: 1rem;
    font-weight: 600;
    line-height: 24px;
    border-radius: 0px;
    &:first-child {
      border-top-left-radius: 4px;
    }
    &:last-child {
      border-top-right-radius: 4px;
    }
  }
`

export const StyledBodyCell = styled(TableCell)`
  white-space: ${({ column }) => (column === 'Responsável' || column === 'Razão Social' ? 'nowrap' : 'wrap')};

  overflow: ${({ column }) => (column === 'Responsável' || column === 'Razão Social' ? 'hidden' : 'none')};

  text-overflow: ${({ column }) => (column === 'Responsável' || column === 'Razão Social' ? 'ellipsis' : 'none')};
  max-width: ${({ column }) => (column === 'Responsável' || column === 'Razão Social' ? '100px' : '200px')};
`

const opacity = '15'

export const WrapperPagination = styled.div`
  display: ${({ isLoading }) => (isLoading ? 'none' : 'flex')};
  justify-content: center;
  width: 100%;
  margin: 24px 0px;
`

export const PaginationButton = styled.span`
  outline: none;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 4px;
  margin: 0 5px;
  display: flex;
  font-size: 14px;
  line-height: 24px;
  align-items: center;
  text-align: center;
  justify-content: center;
  cursor: pointer;
  ${({ isSelected, disabled, isLoading, theme: { palette } }) => `
      background: ${isSelected ? palette.primary.main : 'none'};
      color: ${isSelected ? palette.white : palette.gray['800']};
      opacity: ${disabled && !isSelected ? '0.5' : '1'};
      &:disabled {
        cursor: ${isSelected || isLoading ? 'pointer' : 'not-allowed'};
      }
      &:hover {
        background: ${palette.primary.main + (!isSelected ? opacity : '')};
      }
    `}

  &:first-of-type {
    margin-left: 0;
  }
  &:last-of-type {
    margin-right: 0;
  }

  :focus {
    background-color: #076f9f !important;
  }
`

export const Control = styled.button`
  border: none;
  outline: none;
  width: 24px;
  height: 24px;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  &:first-of-type {
    margin-right: 8px;
  }
  &:last-of-type {
    margin-left: 8px;
  }
  ${({ disabled, isLoading }) => `
    cursor: ${disabled || isLoading ? 'not-allowed' : 'pointer'};
`}
`
